// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"29d17b22","114":"751144c6","495":"4c3ef2fc","520":"e198ac8b","649":"9443f9f9","650":"59e2df02","799":"4646897e","928":"cfd4084e"}[chunkId] + ".chunk.js";
};